export const SET_FEATURED = 'SET_FEATURED'
export const SET_MYLIST = 'SET_MYLIST'
